export default __webpack_public_path__ + "static/media/img-b-result-distance-na_en@2x.e1f93ddd.jpg";